import { styled, TableRow } from '@mui/material';

const StyledRow = styled(TableRow)(({ theme }) => ({
  '& .advancedAnalysisItem': {
    '& p': {
      width: 'fit-content',
    },
  },
  '& .factCheckModule': {
    verticalAlign: 'top',
    '& p': {
      width: 'fit-content',
    },
  },
  '& .fact-check-accordion': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&::before': {
      display: 'none',
    },
  },
  '& .fact-check-summary': {
    minHeight: 'unset',
    padding: 0,
    '& .MuiAccordionSummary-content': {
      margin: 0,
      flexGrow: 0,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginLeft: 4,
    },
  },
  '& .fact-check-details': {
    padding: '8px 0 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& .attribute-line': {
      display: 'flex',
      alignItems: 'baseline',
      gap: 8,
    },
    '& .attribute-label': {
      fontSize: 12,
      fontWeight: 600,
    },
    '& .attribute-verdict': {
      fontSize: 12,
      whiteSpace: 'nowrap',
      '&.Correct': {
        color: theme.palette.success.main,
      },
      '&.Incorrect': {
        color: theme.palette.error.main,
      },
      '&.NotMentioned': {
        color: theme.palette.text.secondary,
      },
    },
  },
  '& .complianceOperationItem': {
    verticalAlign: 'top',
  },
  '& .compliance-operation-accordion': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&::before': {
      display: 'none',
    },
  },
  '& .compliance-operation-summary': {
    minHeight: 'unset',
    padding: 0,
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginLeft: 4,
    },
  },
  '& .compliance-operation-details': {
    padding: '8px 0 0',
  },
}));

export default StyledRow;
